import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './SVG';
import {FormattedMessage, FormattedHTMLMessage, injectIntl} from 'react-intl';

const FooterStbLink = injectIntl(({href, intl}) => (
	<a href={intl.formatMessage({id:href})} target="_blank">
		<FormattedMessage id="footer.stbs" />
	</a>
));

class Footer extends Component {
	render(){
		const {localizePath, selectedLanguage} = this.props;

		const privacyPolicyLink = selectedLanguage.code.includes('hu') ? '/hu/adatvedelem.pdf' : '/privacypolicy.pdf';

		return (
			<footer className="main-footer">
				<div className="container-flex">
					<Link className="amiko-logo" to="/">
						<Logo/>
					</Link>
					<div className="main-footer__info">
						<div className="info-block">
							<h3 className="info-block__title">Amiko Technologies</h3>
							<div className="info-block__text">
								<FormattedHTMLMessage id="footer.address" defaultMessage={' '} />
							</div>
						</div>
						<div className="info-block">
							<h3 className="info-block__title"><FormattedMessage id="footer.for-partners" /></h3>
							<ul className="info-block__text">
								<li>
									<Link to={localizePath('/contact-us')}><FormattedMessage id="footer.contact-us" /></Link>
								</li>
								<li>
									<Link to={localizePath('/faq')}><FormattedMessage id="footer.faq" /></Link>
								</li>
							</ul>
						</div>
						<div className="info-block">
							<h3 className="info-block__title"><FormattedMessage id="footer.products" /></h3>
							<ul className="info-block__text">
								<li>
									<a href="https://play.google.com/store/apps/details?id=com.amikohome.smarthome" target="_blank">
										<FormattedMessage id="footer.amikohome-android-app" />
									</a>
								</li>
								<li>
									<a href="https://itunes.apple.com/us/app/amiko-home/id1394418929?mt=8" target="_blank">
										<FormattedMessage id="footer.amikohome-ios-app" />
									</a>
								</li>
								<li>
									<FooterStbLink href={'footer.stbs.link'}/>
								</li>
							</ul>
						</div>
						<div className="info-block">
							<h3 className="info-block__title">Amiko Home</h3>
							<ul className="info-block__text">
								<li><FormattedMessage id="footer.slogen" /></li>
								<li>
									<a href="https://www.iubenda.com/privacy-policy/8131574/full-legal" target="_blank">
										<FormattedMessage id="footer.privacy-policy-mobile" />
									</a>
								</li>
								<li>
									<a href={privacyPolicyLink} target="_blank">
										<FormattedMessage id="footer.privacy-policy" />
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="main-footer__copyright">
					<FormattedHTMLMessage id="footer.copyright"/>
				</div>
			</footer>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/common/Footer.js